import { isProd } from "utils/env";
import { getRemoteFlags } from "./firebase";
import {
  CHANGE_NECTAR_ACCOUNT_FLAG,
  WEB_AUTHN_FLAG,
  SSO_FLAG,
} from "./featureFlagKeys";
export {
  CHANGE_NECTAR_ACCOUNT_FLAG,
  WEB_AUTHN_FLAG,
  SSO_FLAG,
} from "./featureFlagKeys";

const flagExists = (flag) => Boolean(sessionStorage.getItem(flag));

export const flagEnabled = (flag) => sessionStorage.getItem(flag) === "true";

const defaultFlags = [
  [CHANGE_NECTAR_ACCOUNT_FLAG, "false"],
  [WEB_AUTHN_FLAG, isProd() ? "false" : "true"],
  [SSO_FLAG, isProd() ? "false" : "true"],
];

let flags = [];

export const remoteFlagsFetch = () => {
  console.log("Fetching remote flags - start");
  getRemoteFlags().then((responseData) => {
    responseData.forEach((flag) => {
      console.log("Feature values for flag " + flag);
      if (!flagExists(flag[0])) {
        sessionStorage.setItem(...flag);
      }
    });
    console.log("Fetching remote flags - finish");
  });
};

if (isProd()) {
  remoteFlagsFetch();
} else {
  flags = defaultFlags;
}

export default () => {
  flags.forEach((flag) => {
    if (!isProd() && flagEnabled(flag[0])) {
      console.log(`[FF] ${flag[0]} feature enabled!`);
    }

    if (!flagExists(flag[0])) {
      sessionStorage.setItem(...flag);
    }
  });
};
